import React, { useEffect, useState } from 'react';
import HeaderComponent from '../../../../components/header/Header.component';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Loading from '../../../../components/portalComponents/Loading.component';
import { cross } from '../../../../utils/Logo';
import { t } from 'i18next';
import StatusAlertPopup from '../../../../components/moduleCommonFormik/StatusAlertPopup';
import { EMPLOYEE_AUTHORIZED } from '../../../../utils/constants';
import { endpoints, getMenuData, POST, requestInfo } from '../../../../services/modulesServices/userManagement.api';
import { convertToHierarchyCard } from '../../../../utils/utils';
import NewUserDashboard from '../New Dashboard/NewUserDashboard';
import NewEnterpriseDashboard from '../New Dashboard/NewEnterpriseDashboard';
import FooterComponent from '../../../../components/portalComponents/Footer.component';
import mapImage from '../../../../assets/logos/mapimg.svg';
import SubleaseSection from '../New Dashboard/SubleaseSection';
import paid from '../../../../assets/logos/check Circle.svg';
import due from '../../../../assets/logos/pay due.svg';
import overdue from '../../../../assets/logos/pay over due.svg';
import PaymentSection from '../New Dashboard/PaymentSection';
import { DocumentSection } from '../New Dashboard/DocumentSection';
import { PlotInfoSection } from '../New Dashboard/PlotInfoSection';
import { getBuiltUpArea, getTransferBuildUpArea } from '../../../../services/technicalServices/Technical.service';
import GenericHeader from '../../../../components/moduleCommonFormik/GenericHeader';

function EnterpriseDashboardView() {
    const [searchParams] = useSearchParams();
    const entityId = searchParams.get('uuid') || '';
    let userObject = JSON.parse(localStorage.getItem('user') || '{}');
    let userType = userObject?.type;
    let navigate = useNavigate();
    const codesToCheck = ['ALLOTTEE', 'LESSEE'];
    const codesToCheckForCards = ['ALLOTTEE', 'LESSEE', 'APPLICANT', 'TRANSFEREE_APPLICANT', 'TRANSFEREE'];

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [modalDetails, setModalDetails] = useState<any>({});
    const [data, setData] = useState<any>(null);
    const [conditions, setConditions] = useState<any>(null);
    const [enterpriseSearchData, setEnterpriseSearchData] = useState<any>({});
    const [entityRefDetails, setEntityRefDetails] = useState<any>(null);
    const [currentPlotDetails, setCurrentPlotDetails] = useState<any>(null);
    const [activePlot, setActivePlot] = useState(0);
    const [migartedPlot, setMigratedPlot] = useState<boolean>(false);
    const [allDocuments, setAllDocuments] = useState<any>(null);
    const [coExpiryDate, setCoExpiryDate] = useState<any>(null);
    const [deedExecutedDate, setDeedExecutedDate] = useState<any>(null);
    const [builtUpPercentage, setBuiltUpPercentage] = useState<any>(null);
    const [builtUpArea, setBuiltUpArea] = useState<any>(null);
    const [mortgageData, setMortgageData] = useState<any>([]);

    useEffect(() => {
        if (userType === 'EMPLOYEE' && entityId) {
            (async () => {
                try {
                    setIsLoading(true);

                    const { data: enterpriseData } = await POST(endpoints.searchExistingUser + `?uuids=${entityId}`, { RequestInfo: requestInfo() });
                    setEnterpriseSearchData(enterpriseData?.enterpriseEntity?.[0]);

                    const { data } = await POST(endpoints.entityRefDetails + `?isPlotDetailsRequired=true&entityIds=${entityId}`, { RequestInfo: requestInfo() });
                    const plotData = data.entityRefDetails.filter((item: any) => codesToCheck.includes(item.type)).reverse();
                    plotData && setData(plotData);
                    plotData && setEntityRefDetails(plotData);

                    const {
                        data: { deedDetails }
                    } = await POST(endpoints.leaseDeedSearch + `?entityIds=${entityId}&plotIds=${plotData?.[0]?.plotId}`, { RequestInfo: requestInfo() });
                    plotData?.[0] && setCurrentPlotDetails({ ...plotData?.[0], leaseTermEndDate: deedDetails[0]?.termEndDate });
                    plotData?.[0] && setMigratedPlot(plotData?.[0]?.auditDetails?.createdBy === 'DATA_MIGRATION_API' ? true : false);

                    const { data: mortgageData } = await POST(endpoints?.searchMortgage + `?statusList=OPEN,APPROVED&entityIds=${entityId}&plotIds=${plotData?.[0]?.plotId}`, {
                        RequestInfo: requestInfo()
                    });
                    setMortgageData(mortgageData?.MortgageDetails);

                    const tempData = data.entityRefDetails.filter((item: any) => codesToCheckForCards.includes(item.type));
                    setConditions(tempData);

                    setIsLoading(false);
                } catch (e: any) {
                    setIsLoading(false);
                    let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
                    setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
                }
            })();
        }
        if (userType !== 'EMPLOYEE') {
            setModalDetails({
                show: true,
                title: t('ERROR', 'Error!'),
                para: t('UNAUTHORIZED_ACCESS', EMPLOYEE_AUTHORIZED),
                img: cross,
                type: 'error',
                reUpload: 'OK',
                isUnauthorized: true
            });
        }
    }, []);

    useEffect(() => {
        if (currentPlotDetails?.plotId) {
            (async () => {
                try {
                    setIsLoading(true);
                    const { data: docs } = await POST(endpoints.dashboardDocumentSearch + `?entityIds=${entityId}&plotIds=${currentPlotDetails?.plotId}`, { RequestInfo: requestInfo() });
                    setAllDocuments(docs);
                    const tempDocData = docs?.deedDetails?.filter((val: any) => val.deedType === 'LEASE_DEED' || val.deedType === 'TRIPARTITE_DEED');
                    const exeDate = tempDocData?.[0]?.deedExecutionDate?.split(' ')[0];
                    setDeedExecutedDate(exeDate);

                    const { data: commercialCertificate } = await POST(endpoints.commercialCertificateSearch + `?entityIds=${entityId}&plotIds=${currentPlotDetails?.plotId}&statuses=APPROVED`, {
                        RequestInfo: requestInfo()
                    });
                    setCoExpiryDate(commercialCertificate?.commercialOpsDetails[0]?.expiryDate);

                    const builtUp = await getTransferBuildUpArea(entityId, currentPlotDetails?.plotId, { RequestInfo: requestInfo() });
                    setBuiltUpPercentage(builtUp?.data);

                    const builtUpArea = await getBuiltUpArea(currentPlotDetails?.plotId, entityId, { RequestInfo: requestInfo() });
                    setBuiltUpArea(builtUpArea?.data?.builtUpArea);
                    setIsLoading(false);
                } catch (e: any) {
                    setIsLoading(false);
                    let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
                    setModalDetails({ show: true, title: t('ERROR', 'Error!'), para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
                }
            })();
        }
    }, [currentPlotDetails]);

    const handleModalClose = (type: string, isUnauthorized?: boolean) => {
        setModalDetails({ show: false });
        if (isUnauthorized) {
            if (userType === 'ENTERPRISE') {
                navigate('/goa-idc/enterprisedashboard');
            } else if (userType === 'EXTERNAL_EMPLOYEE') {
                navigate('/goa-idc/architectdashboard');
            }
        }
    };

    const onChangePlot = async (plot: any, index: number) => {
        try {
            const deedData = await POST(endpoints.leaseDeedSearch + `?entityIds=${entityId}&plotIds=${plot?.plotId}`, { RequestInfo: requestInfo() });
            plot && setCurrentPlotDetails({ ...plot, leaseTermEndDate: deedData.data.deedDetails[0]?.termEndDate });

            const { data: mortgageData } = await POST(endpoints?.searchMortgage + `?statusList=OPEN,APPROVED&entityIds=${entityId}&plotIds=${plot?.plotId}`, { RequestInfo: requestInfo() });
            setMortgageData(mortgageData?.MortgageDetails);

            setActivePlot(index);
            setMigratedPlot(plot?.auditDetails?.createdBy === 'DATA_MIGRATION_API' ? true : false);
        } catch (e: any) {
            setIsLoading(false);
            let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
            setModalDetails({ show: true, title: t('ERROR', 'Error!'), para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    return (
        <div>
            <HeaderComponent />
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <>
                        <div className='row new-enterprise-dashboard new-dashboard px-5 pb-3 gx-0 justify-content-center mt-3' style={{ backgroundColor: '#F5F5F5' }}>
                            <GenericHeader text={enterpriseSearchData?.entityName} />
                            {/* <div className='col-12 mt-4 d-flex justify-content-between align-items-center ' style={{ height: '50px' }}>
                                <div>
                                    <div className='font-28  font-inter user-name fw-bold '>{`${enterpriseSearchData?.entityName}`}</div>
                                </div>
                            </div> */}
                        </div>

                        {!conditions?.length ? (
                            <>
                                <div className='row new-dashboard px-5 gx-0 justify-content-center min-vh-100 position-fixed w-100 ' style={{ backgroundColor: '#F5F5F5' }}>
                                    <div className='col-6  d-flex flex-column justify-content-center text-center position-absolute ' style={{ height: 'fit-content' }}>
                                        <img src={mapImage} alt='dashboardImage' height={260} />
                                        <div className='content  mt-4 '>
                                            <div className='content-heading font-24 fw-semibold font-inter text-center mb-3'>Start with applying for plot.</div>
                                            <div className='content-details text-center font-14 fw-500 font-inter mb-3'>
                                                {t('THANKYOU_REG_GOA_PORTAL', ' Thank you for registering to Goa IDC portal. Please apply for a plot via these 3 below options.')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='position-fixed bottom-0  w-100 d-non'>
                                    <FooterComponent onlyCopyright={true} />
                                </div>
                            </>
                        ) : (
                            <>
                                {enterpriseSearchData?.user?.roles?.some((item: any) => codesToCheck.includes(item.code)) && (
                                    <>
                                        <div className='row new-enterprise-dashboard new-dashboard px-5 pb-5 gx-0 justify-content-center ' style={{ backgroundColor: '#F5F5F5' }}>
                                            <>
                                                <div className='col-12 mt-3'>
                                                    <div className='plot-list d-flex px-3 rounded-pill align-items-center gap-2  '>
                                                        {entityRefDetails?.map((item: any, ind: number) => (
                                                            <div
                                                                className={`plot-items font-inter font-18 fw-500 p-2 cursor-pointer ${activePlot === ind ? 'project-primary-color bg-white rounded-pill ' : ''}`}
                                                                onClick={() => onChangePlot(item, ind)}
                                                                data-toggle='tooltip'
                                                                data-placement='top'
                                                                title={`${item?.plotDetails?.plotNo} ${item?.auditDetails?.createdBy === 'DATA_MIGRATION_API' ? '\n(Migrated Plot)' : ''}`}
                                                            >
                                                                {`Plot-${ind + 1}`}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div className='col-12 px-2 mt-3 font-inter new-dashboard-details'>
                                                    <div className='row px-1'>
                                                        <PlotInfoSection
                                                            currentPlotDetails={currentPlotDetails}
                                                            allDocuments={allDocuments}
                                                            coExpiryDate={coExpiryDate}
                                                            deedExecutedDate={deedExecutedDate}
                                                            builtUpPercentage={builtUpPercentage}
                                                            builtUpArea={builtUpArea}
                                                            migartedPlot={migartedPlot}
                                                            isEmployeeView={true}
                                                            entityId={entityId}
                                                            mortgageData={mortgageData}
                                                        />
                                                        <div className='col-12 col-lg-8 col-md-12 col-sm-12 plot-cards mt-3 p-0'>
                                                            <div className='d-flex gy-3 '>
                                                                <PaymentSection iconProps={[paid, due, overdue]} currentPlotDetails={currentPlotDetails} uuid={entityId} isEmployeeView={true} />
                                                                <DocumentSection
                                                                    currentPlotDetails={currentPlotDetails}
                                                                    modalDetails={modalDetails}
                                                                    setModalDetails={setModalDetails}
                                                                    allDocuments={allDocuments}
                                                                    plotData={data}
                                                                    isEmployeeView={true}
                                                                    entityId={entityId}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-12 px-2 mt-3 font-inter new-dashboard-details'>
                                                    <SubleaseSection
                                                        iconProps={[paid, due, overdue]}
                                                        currentPlotDetails={currentPlotDetails}
                                                        modalDetails={modalDetails}
                                                        setModalDetails={setModalDetails}
                                                        uuid={entityId}
                                                        isEmployeeView={true}
                                                        // setIsLoading={setIsLoading}
                                                    />
                                                </div>
                                            </>
                                            {/* )} */}
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </>
                </>
            )}
            <StatusAlertPopup
                title={modalDetails.title}
                para={modalDetails.para}
                img={modalDetails.img}
                show={modalDetails.show}
                handleClose={() => handleModalClose(modalDetails.type, modalDetails?.isUnauthorized)}
                type={modalDetails.type}
                reUpload={modalDetails.reUpload}
                handleSubmit={() => handleModalClose(modalDetails.type, modalDetails?.isUnauthorized)}
            />
        </div>
    );
}

export default EnterpriseDashboardView;
